class Photo < ApplicationRecord
  validates :image_data, presence: true

  # Broadcast new photos to all connected users
  broadcasts_to -> { "photos" }, inserts_by: :prepend
end
